<div class="page-content-main box-panel shadow max-w max-gs pt-5 mt-5" id="page-content-main">
  <div class="container m--full-bleed">
    <div class="form-display-card">
      <mat-card class='mat-card-display mb-4 pt-5'>
        <mat-card-header>
          <mat-card-title class="justify-content-right">
            <h2 class="mat-card-title align-items-start">
              <span class="fa fa-credit-card fa-md-black mr-2"></span> Credit Card Payment Successful
            </h2>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div id="section-visible">
            <p class="mb-5">Your payment has been successfully processed and a receipt has been sent to the email
              address you provided.</p>
            <div class="row m--full-bleed">
              <div class="col-12 col-md-6">
                <dl class="account-details-sum">
                  <div class="account-sum-row">
                    <dt class="account-dt">Name</dt>
                    <dd class="account-dt-info">{{ fullName }}</dd>
                  </div>
                  <div class="account-sum-row">
                    <dt class="account-dt">Date</dt>
                    <dd class="account-dt-info">{{ paymentDate | date:'MM/dd/yyyy' }}</dd>
                  </div>
                  <div class="account-sum-row">
                    <dt class="account-dt">Confirmation Number</dt>
                    <dd class="account-dt-info">{{confirmationId}}</dd>
                  </div>
                  <div class="account-sum-row">
                    <dt class="account-dt">Transaction ID</dt>
                    <dd class="account-dt-info">{{ transactionId }}</dd>
                  </div>
                </dl>
              </div>
              <div class="col-12 col-md-6">
                <dl class="account-details-sum">
                  <div class="account-sum-row">
                    <dt class="account-dt">Total Amount</dt>
                    <dd class="account-dt-info">{{totalAmount | currency}}</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div class="t-alignC pt-2 pb-2">
        <button class="btn" (click)="GoToHomePage()">Home</button>
        <button class="btn" (click)="Print()">Print</button>
      </div>
    </div>
  </div>
</div>

<div id="print-section">
  <p class="mb-5">Your payment has been successfully processed and a receipt has been sent to the email
    address you provided.</p>
  <div class="row m--full-bleed">
    <div class="col-12 col-md-6">
      <dl class="account-details-sum">
        <div class="account-sum-row">
          <dt class="account-dt">Name</dt>
          <dd class="account-dt-info">{{ fullName }}</dd>
        </div>
        <div class="account-sum-row">
          <dt class="account-dt">Date</dt>
          <dd class="account-dt-info">{{ paymentDate | date:'MM/dd/yyyy' }}</dd>
        </div>
        <div class="account-sum-row">
          <dt class="account-dt">Confirmation Number</dt>
          <dd class="account-dt-info">{{ confirmationId }}</dd>
        </div>
        <div class="account-sum-row">
          <dt class="account-dt">Transaction ID</dt>
          <dd class="account-dt-info">{{ transactionId }}</dd>
        </div>
      </dl>
    </div>
    <div class="col-12 col-md-6">
      <dl class="account-details-sum">
        <div class="account-sum-row">
          <dt class="account-dt">Total Amount</dt>
          <dd class="account-dt-info">{{ totalAmount | currency}}</dd>
        </div>
      </dl>
    </div>
  </div>
</div>
